import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { OktaService } from 'src/app/services/okta.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  standalone: false
})
export class AccountComponent  implements OnInit {

  selectedOption: boolean = false;
  triggerDeleteConfirmation: boolean = false;
  userDetails : any;
  form = this.fb.group({
    firstName: ["", Validators.required],
    lastName: ["", Validators.required],
    email: ['', [Validators.required, Validators.email]],
    country:  ["", Validators.required],
    company: [""]
  });
  countries: any;
  constructor(private fb: FormBuilder, private modalController: ModalController,
    private cdr: ChangeDetectorRef, private dataService: DataService,
    private oktaService: OktaService) { 
      this.dataService.getCountries().subscribe(countries => {
        this.countries = countries;
      });
  }

  async ngOnInit() {
    this.userDetails = await this.oktaService.userInfo();
    
    this.form.statusChanges.subscribe(status => {
      this.selectedOption = status === 'VALID';
    });
    
     
      if(this.userDetails) {
        this.form.get('firstName')?.setValue(this.userDetails?.name.split(" ")[0]);
        this.form.get('lastName')?.setValue(this.userDetails?.name.split(" ")[1]);
        this.form.get('email')?.setValue(this.userDetails?.email);
        //this.form.get('country')?.setValue(this.userDetails?.country);
        this.form.get('company')?.setValue(this.userDetails?.company);

        
      }
      this.form.get('country')?.disable();
      console.log(this.form)
  }

  ionViewDidEnter() {
    if(this.userDetails?.country) {
          console.log(this.userDetails?.country , " present")
          if(this.countries) {
            console.log(this.countries , " present")
            this.countries.forEach((country:any) => {
              if(country.code == this.userDetails?.country) {
                console.log("matched")
                this.form.get('country')?.setValue(country);
              }
            })
          }
        }
  }

  closeLogin() {
    if(!this.triggerDeleteConfirmation)
      this.modalController.dismiss(null, 'cancel');
    else this.triggerDeleteConfirmation = false;
  }

  validate(){

  }

  triggerConfirmDelete(){
    this.triggerDeleteConfirmation = !this.triggerDeleteConfirmation;
  }

  confirmDelete(){
    console.log("attempting to delete "+this.userDetails);
    console.log(this.userDetails)
    this.oktaService.deactivateUser(this.userDetails?.sub, this.userDetails?.email).subscribe(
      response => {
        console.log("user deactivated ", response);
      }
    )
  }
  editUserDetails(){

  }

}
